import React, { Component } from "react";
import { Alert, Col } from "antd";
import Spinner from '../../spinner/spinner';
import HorizontalStackChart from '../../charts/horizontalStackChart';
import { valuesComparator } from "../../../utilities/comparators";
import "./barriersChart.css";
import "./barriers.css";

const totalBarrierCardMessage = <div>Barriers<br/>totaly submitted</div>;

export default class BarriersChart extends Component {
  constructor(props) {
    super(props);
    this.state = { submitedBarriers: this.props.data.statistics.churchManager.church.submittedBarriers };
  }

  get chartData() {
    const chartData = this.state.submitedBarriers.barriers.map((barrier) => {
      return { y: barrier.total, x: barrier.barrier.name };
    });
    chartData.sort((firstBarrier, secondBarrier) => valuesComparator(firstBarrier.y, secondBarrier.y));
    if (this.state.submitedBarriers.otherBarriers.length !== 0) {
      chartData.unshift({ x: 'Others', y: this.state.submitedBarriers.otherBarriers.length });
    }
    return chartData;
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    }
    return (
      <div>
        <h2 style={{marginBottom: 10}}>Barriers</h2>
        <div>
          <Col span={3}>
            <Alert className="barriers-layout__total-barriers-card"
                   message={this.state.submitedBarriers.totalBarriers}
                   description={totalBarrierCardMessage}
            />
          </Col>
          <Col offset={2} className="barriers-layout__barriers-chart">
            <HorizontalStackChart
              primaryColor="#8483d2"
              secondaryColor="#797979"
              padding={{top: 25, bottom: 50}}
              data={this.chartData}
            />
          </Col>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/barriers/barriersChart.js